/**
 * Generated by orval v7.18.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query'
import type {
    DataTag,
    DefinedInitialDataOptions,
    DefinedUseQueryResult,
    MutationFunction,
    QueryClient,
    QueryFunction,
    QueryKey,
    UndefinedInitialDataOptions,
    UseMutationOptions,
    UseMutationResult,
    UseQueryOptions,
    UseQueryResult,
} from '@tanstack/react-query'

import { customInstance } from '../../../customInstance'
import type { ErrorType, BodyType } from '../../../customInstance'
import type {
    GetRequestJobsFilesAsArchiveByJobUuidParams,
    GetRequestJobsFilesByIdByJobUuidAndFileUuidAndNameBodies,
    GetRequestJobsFilesByIdByJobUuidAndFileUuidAndNameParams,
    GetRequestJobsFilesByIdByJobUuidAndFileUuidAndPathParams,
    GetRequestJobsFilesByIdByJobUuidAndFileUuidBodies,
    GetRequestJobsFilesByIdByJobUuidAndFileUuidParams,
    GetRequestJobsFilesFromTrashAsArchiveByJobUuidParams,
    HTTPValidationErrorDTO,
    PostRequestJobsFilesAsArchiveByJobUuidParams,
    PostRequestJobsFilesFromTrashAsArchiveByJobUuidParams,
    SubFileStatusResponseDTO,
} from '../../model'

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

/**
 * this api call is used to download a file.

 * @summary Get File
 */
export const getRequestJobsFilesByIdByJobUuidAndFileUuid = (
    jobUuid: string,
    fileUuid: string,
    _getRequestJobsFilesByIdByJobUuidAndFileUuidBodies: BodyType<GetRequestJobsFilesByIdByJobUuidAndFileUuidBodies>,
    params: GetRequestJobsFilesByIdByJobUuidAndFileUuidParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<SubFileStatusResponseDTO>(
        {
            url: `/jobs/${encodeURIComponent(String(jobUuid))}/files_by_id/${encodeURIComponent(String(fileUuid))}`,
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
            params,
            signal,
        },
        options,
    )
}

export const getGetRequestJobsFilesByIdByJobUuidAndFileUuidQueryKey = (
    jobUuid?: string,
    fileUuid?: string,
    getRequestJobsFilesByIdByJobUuidAndFileUuidBodies?: GetRequestJobsFilesByIdByJobUuidAndFileUuidBodies,
    params?: GetRequestJobsFilesByIdByJobUuidAndFileUuidParams,
) => {
    return [
        `/jobs/${jobUuid}/files_by_id/${fileUuid}`,
        ...(params ? [params] : []),
        getRequestJobsFilesByIdByJobUuidAndFileUuidBodies,
    ] as const
}

export const getGetRequestJobsFilesByIdByJobUuidAndFileUuidQueryOptions = <
    TData = Awaited<ReturnType<typeof getRequestJobsFilesByIdByJobUuidAndFileUuid>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    fileUuid: string,
    getRequestJobsFilesByIdByJobUuidAndFileUuidBodies: GetRequestJobsFilesByIdByJobUuidAndFileUuidBodies,
    params: GetRequestJobsFilesByIdByJobUuidAndFileUuidParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobsFilesByIdByJobUuidAndFileUuid>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {}

    const queryKey =
        queryOptions?.queryKey ??
        getGetRequestJobsFilesByIdByJobUuidAndFileUuidQueryKey(
            jobUuid,
            fileUuid,
            getRequestJobsFilesByIdByJobUuidAndFileUuidBodies,
            params,
        )

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getRequestJobsFilesByIdByJobUuidAndFileUuid>>
    > = ({ signal }) =>
        getRequestJobsFilesByIdByJobUuidAndFileUuid(
            jobUuid,
            fileUuid,
            getRequestJobsFilesByIdByJobUuidAndFileUuidBodies,
            params,
            requestOptions,
            signal,
        )

    return {
        queryKey,
        queryFn,
        enabled: !!(jobUuid && fileUuid),
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<ReturnType<typeof getRequestJobsFilesByIdByJobUuidAndFileUuid>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRequestJobsFilesByIdByJobUuidAndFileUuidQueryResult = NonNullable<
    Awaited<ReturnType<typeof getRequestJobsFilesByIdByJobUuidAndFileUuid>>
>
export type GetRequestJobsFilesByIdByJobUuidAndFileUuidQueryError =
    ErrorType<void | HTTPValidationErrorDTO>

export function useGetRequestJobsFilesByIdByJobUuidAndFileUuid<
    TData = Awaited<ReturnType<typeof getRequestJobsFilesByIdByJobUuidAndFileUuid>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    fileUuid: string,
    getRequestJobsFilesByIdByJobUuidAndFileUuidBodies: GetRequestJobsFilesByIdByJobUuidAndFileUuidBodies,
    params: GetRequestJobsFilesByIdByJobUuidAndFileUuidParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobsFilesByIdByJobUuidAndFileUuid>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRequestJobsFilesByIdByJobUuidAndFileUuid>>,
                    TError,
                    Awaited<ReturnType<typeof getRequestJobsFilesByIdByJobUuidAndFileUuid>>
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRequestJobsFilesByIdByJobUuidAndFileUuid<
    TData = Awaited<ReturnType<typeof getRequestJobsFilesByIdByJobUuidAndFileUuid>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    fileUuid: string,
    getRequestJobsFilesByIdByJobUuidAndFileUuidBodies: GetRequestJobsFilesByIdByJobUuidAndFileUuidBodies,
    params: GetRequestJobsFilesByIdByJobUuidAndFileUuidParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobsFilesByIdByJobUuidAndFileUuid>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRequestJobsFilesByIdByJobUuidAndFileUuid>>,
                    TError,
                    Awaited<ReturnType<typeof getRequestJobsFilesByIdByJobUuidAndFileUuid>>
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRequestJobsFilesByIdByJobUuidAndFileUuid<
    TData = Awaited<ReturnType<typeof getRequestJobsFilesByIdByJobUuidAndFileUuid>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    fileUuid: string,
    getRequestJobsFilesByIdByJobUuidAndFileUuidBodies: GetRequestJobsFilesByIdByJobUuidAndFileUuidBodies,
    params: GetRequestJobsFilesByIdByJobUuidAndFileUuidParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobsFilesByIdByJobUuidAndFileUuid>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get File
 */

export function useGetRequestJobsFilesByIdByJobUuidAndFileUuid<
    TData = Awaited<ReturnType<typeof getRequestJobsFilesByIdByJobUuidAndFileUuid>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    fileUuid: string,
    getRequestJobsFilesByIdByJobUuidAndFileUuidBodies: GetRequestJobsFilesByIdByJobUuidAndFileUuidBodies,
    params: GetRequestJobsFilesByIdByJobUuidAndFileUuidParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobsFilesByIdByJobUuidAndFileUuid>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getGetRequestJobsFilesByIdByJobUuidAndFileUuidQueryOptions(
        jobUuid,
        fileUuid,
        getRequestJobsFilesByIdByJobUuidAndFileUuidBodies,
        params,
        options,
    )

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>
    }

    query.queryKey = queryOptions.queryKey

    return query
}

/**
 * This call is deprecated use the same call minus name
This api call is used to download a file.

The name parameter is mandatory but it is not used to get file, since
the file uuid is distinct so no name is needed
 * @summary Get File With Name
 */
export const getRequestJobsFilesByIdByJobUuidAndFileUuidAndName = (
    jobUuid: string,
    fileUuid: string,
    name: string,
    _getRequestJobsFilesByIdByJobUuidAndFileUuidAndNameBodies: BodyType<GetRequestJobsFilesByIdByJobUuidAndFileUuidAndNameBodies>,
    params: GetRequestJobsFilesByIdByJobUuidAndFileUuidAndNameParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<SubFileStatusResponseDTO>(
        {
            url: `/jobs/${encodeURIComponent(String(jobUuid))}/files_by_id/${encodeURIComponent(String(fileUuid))}/${encodeURIComponent(String(name))}`,
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
            params,
            signal,
        },
        options,
    )
}

export const getGetRequestJobsFilesByIdByJobUuidAndFileUuidAndNameQueryKey = (
    jobUuid?: string,
    fileUuid?: string,
    name?: string,
    getRequestJobsFilesByIdByJobUuidAndFileUuidAndNameBodies?: GetRequestJobsFilesByIdByJobUuidAndFileUuidAndNameBodies,
    params?: GetRequestJobsFilesByIdByJobUuidAndFileUuidAndNameParams,
) => {
    return [
        `/jobs/${jobUuid}/files_by_id/${fileUuid}/${name}`,
        ...(params ? [params] : []),
        getRequestJobsFilesByIdByJobUuidAndFileUuidAndNameBodies,
    ] as const
}

export const getGetRequestJobsFilesByIdByJobUuidAndFileUuidAndNameQueryOptions = <
    TData = Awaited<ReturnType<typeof getRequestJobsFilesByIdByJobUuidAndFileUuidAndName>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    fileUuid: string,
    name: string,
    getRequestJobsFilesByIdByJobUuidAndFileUuidAndNameBodies: GetRequestJobsFilesByIdByJobUuidAndFileUuidAndNameBodies,
    params: GetRequestJobsFilesByIdByJobUuidAndFileUuidAndNameParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobsFilesByIdByJobUuidAndFileUuidAndName>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {}

    const queryKey =
        queryOptions?.queryKey ??
        getGetRequestJobsFilesByIdByJobUuidAndFileUuidAndNameQueryKey(
            jobUuid,
            fileUuid,
            name,
            getRequestJobsFilesByIdByJobUuidAndFileUuidAndNameBodies,
            params,
        )

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getRequestJobsFilesByIdByJobUuidAndFileUuidAndName>>
    > = ({ signal }) =>
        getRequestJobsFilesByIdByJobUuidAndFileUuidAndName(
            jobUuid,
            fileUuid,
            name,
            getRequestJobsFilesByIdByJobUuidAndFileUuidAndNameBodies,
            params,
            requestOptions,
            signal,
        )

    return {
        queryKey,
        queryFn,
        enabled: !!(jobUuid && fileUuid && name),
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<ReturnType<typeof getRequestJobsFilesByIdByJobUuidAndFileUuidAndName>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRequestJobsFilesByIdByJobUuidAndFileUuidAndNameQueryResult = NonNullable<
    Awaited<ReturnType<typeof getRequestJobsFilesByIdByJobUuidAndFileUuidAndName>>
>
export type GetRequestJobsFilesByIdByJobUuidAndFileUuidAndNameQueryError =
    ErrorType<void | HTTPValidationErrorDTO>

export function useGetRequestJobsFilesByIdByJobUuidAndFileUuidAndName<
    TData = Awaited<ReturnType<typeof getRequestJobsFilesByIdByJobUuidAndFileUuidAndName>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    fileUuid: string,
    name: string,
    getRequestJobsFilesByIdByJobUuidAndFileUuidAndNameBodies: GetRequestJobsFilesByIdByJobUuidAndFileUuidAndNameBodies,
    params: GetRequestJobsFilesByIdByJobUuidAndFileUuidAndNameParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobsFilesByIdByJobUuidAndFileUuidAndName>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRequestJobsFilesByIdByJobUuidAndFileUuidAndName>>,
                    TError,
                    Awaited<ReturnType<typeof getRequestJobsFilesByIdByJobUuidAndFileUuidAndName>>
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRequestJobsFilesByIdByJobUuidAndFileUuidAndName<
    TData = Awaited<ReturnType<typeof getRequestJobsFilesByIdByJobUuidAndFileUuidAndName>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    fileUuid: string,
    name: string,
    getRequestJobsFilesByIdByJobUuidAndFileUuidAndNameBodies: GetRequestJobsFilesByIdByJobUuidAndFileUuidAndNameBodies,
    params: GetRequestJobsFilesByIdByJobUuidAndFileUuidAndNameParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobsFilesByIdByJobUuidAndFileUuidAndName>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRequestJobsFilesByIdByJobUuidAndFileUuidAndName>>,
                    TError,
                    Awaited<ReturnType<typeof getRequestJobsFilesByIdByJobUuidAndFileUuidAndName>>
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRequestJobsFilesByIdByJobUuidAndFileUuidAndName<
    TData = Awaited<ReturnType<typeof getRequestJobsFilesByIdByJobUuidAndFileUuidAndName>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    fileUuid: string,
    name: string,
    getRequestJobsFilesByIdByJobUuidAndFileUuidAndNameBodies: GetRequestJobsFilesByIdByJobUuidAndFileUuidAndNameBodies,
    params: GetRequestJobsFilesByIdByJobUuidAndFileUuidAndNameParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobsFilesByIdByJobUuidAndFileUuidAndName>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get File With Name
 */

export function useGetRequestJobsFilesByIdByJobUuidAndFileUuidAndName<
    TData = Awaited<ReturnType<typeof getRequestJobsFilesByIdByJobUuidAndFileUuidAndName>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    fileUuid: string,
    name: string,
    getRequestJobsFilesByIdByJobUuidAndFileUuidAndNameBodies: GetRequestJobsFilesByIdByJobUuidAndFileUuidAndNameBodies,
    params: GetRequestJobsFilesByIdByJobUuidAndFileUuidAndNameParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobsFilesByIdByJobUuidAndFileUuidAndName>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getGetRequestJobsFilesByIdByJobUuidAndFileUuidAndNameQueryOptions(
        jobUuid,
        fileUuid,
        name,
        getRequestJobsFilesByIdByJobUuidAndFileUuidAndNameBodies,
        params,
        options,
    )

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>
    }

    query.queryKey = queryOptions.queryKey

    return query
}

/**
 * @summary Get File By Path
 */
export const getRequestJobsFilesByIdByJobUuidAndFileUuidAndPath = (
    jobUuid: string,
    fileUuid: string,
    path: string,
    params: GetRequestJobsFilesByIdByJobUuidAndFileUuidAndPathParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<SubFileStatusResponseDTO>(
        {
            url: `/jobs/${encodeURIComponent(String(jobUuid))}/files_by_id/${encodeURIComponent(String(fileUuid))}/${encodeURIComponent(String(path))}`,
            method: 'GET',
            params,
            signal,
        },
        options,
    )
}

export const getGetRequestJobsFilesByIdByJobUuidAndFileUuidAndPathQueryKey = (
    jobUuid?: string,
    fileUuid?: string,
    path?: string,
    params?: GetRequestJobsFilesByIdByJobUuidAndFileUuidAndPathParams,
) => {
    return [
        `/jobs/${jobUuid}/files_by_id/${fileUuid}/${path}`,
        ...(params ? [params] : []),
    ] as const
}

export const getGetRequestJobsFilesByIdByJobUuidAndFileUuidAndPathQueryOptions = <
    TData = Awaited<ReturnType<typeof getRequestJobsFilesByIdByJobUuidAndFileUuidAndPath>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    fileUuid: string,
    path: string,
    params: GetRequestJobsFilesByIdByJobUuidAndFileUuidAndPathParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobsFilesByIdByJobUuidAndFileUuidAndPath>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {}

    const queryKey =
        queryOptions?.queryKey ??
        getGetRequestJobsFilesByIdByJobUuidAndFileUuidAndPathQueryKey(
            jobUuid,
            fileUuid,
            path,
            params,
        )

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getRequestJobsFilesByIdByJobUuidAndFileUuidAndPath>>
    > = ({ signal }) =>
        getRequestJobsFilesByIdByJobUuidAndFileUuidAndPath(
            jobUuid,
            fileUuid,
            path,
            params,
            requestOptions,
            signal,
        )

    return {
        queryKey,
        queryFn,
        enabled: !!(jobUuid && fileUuid && path),
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<ReturnType<typeof getRequestJobsFilesByIdByJobUuidAndFileUuidAndPath>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRequestJobsFilesByIdByJobUuidAndFileUuidAndPathQueryResult = NonNullable<
    Awaited<ReturnType<typeof getRequestJobsFilesByIdByJobUuidAndFileUuidAndPath>>
>
export type GetRequestJobsFilesByIdByJobUuidAndFileUuidAndPathQueryError =
    ErrorType<HTTPValidationErrorDTO>

export function useGetRequestJobsFilesByIdByJobUuidAndFileUuidAndPath<
    TData = Awaited<ReturnType<typeof getRequestJobsFilesByIdByJobUuidAndFileUuidAndPath>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    fileUuid: string,
    path: string,
    params: GetRequestJobsFilesByIdByJobUuidAndFileUuidAndPathParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobsFilesByIdByJobUuidAndFileUuidAndPath>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRequestJobsFilesByIdByJobUuidAndFileUuidAndPath>>,
                    TError,
                    Awaited<ReturnType<typeof getRequestJobsFilesByIdByJobUuidAndFileUuidAndPath>>
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRequestJobsFilesByIdByJobUuidAndFileUuidAndPath<
    TData = Awaited<ReturnType<typeof getRequestJobsFilesByIdByJobUuidAndFileUuidAndPath>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    fileUuid: string,
    path: string,
    params: GetRequestJobsFilesByIdByJobUuidAndFileUuidAndPathParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobsFilesByIdByJobUuidAndFileUuidAndPath>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRequestJobsFilesByIdByJobUuidAndFileUuidAndPath>>,
                    TError,
                    Awaited<ReturnType<typeof getRequestJobsFilesByIdByJobUuidAndFileUuidAndPath>>
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRequestJobsFilesByIdByJobUuidAndFileUuidAndPath<
    TData = Awaited<ReturnType<typeof getRequestJobsFilesByIdByJobUuidAndFileUuidAndPath>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    fileUuid: string,
    path: string,
    params: GetRequestJobsFilesByIdByJobUuidAndFileUuidAndPathParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobsFilesByIdByJobUuidAndFileUuidAndPath>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get File By Path
 */

export function useGetRequestJobsFilesByIdByJobUuidAndFileUuidAndPath<
    TData = Awaited<ReturnType<typeof getRequestJobsFilesByIdByJobUuidAndFileUuidAndPath>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    fileUuid: string,
    path: string,
    params: GetRequestJobsFilesByIdByJobUuidAndFileUuidAndPathParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobsFilesByIdByJobUuidAndFileUuidAndPath>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getGetRequestJobsFilesByIdByJobUuidAndFileUuidAndPathQueryOptions(
        jobUuid,
        fileUuid,
        path,
        params,
        options,
    )

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>
    }

    query.queryKey = queryOptions.queryKey

    return query
}

/**
 * This is a method to download all files from a job.

 * @summary Get Files As Archive
 */
export const getRequestJobsFilesAsArchiveByJobUuid = (
    jobUuid: string,
    params: GetRequestJobsFilesAsArchiveByJobUuidParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<unknown>(
        {
            url: `/jobs/${encodeURIComponent(String(jobUuid))}/files_as_archive`,
            method: 'GET',
            params,
            signal,
        },
        options,
    )
}

export const getGetRequestJobsFilesAsArchiveByJobUuidQueryKey = (
    jobUuid?: string,
    params?: GetRequestJobsFilesAsArchiveByJobUuidParams,
) => {
    return [`/jobs/${jobUuid}/files_as_archive`, ...(params ? [params] : [])] as const
}

export const getGetRequestJobsFilesAsArchiveByJobUuidQueryOptions = <
    TData = Awaited<ReturnType<typeof getRequestJobsFilesAsArchiveByJobUuid>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    params: GetRequestJobsFilesAsArchiveByJobUuidParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobsFilesAsArchiveByJobUuid>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {}

    const queryKey =
        queryOptions?.queryKey ?? getGetRequestJobsFilesAsArchiveByJobUuidQueryKey(jobUuid, params)

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getRequestJobsFilesAsArchiveByJobUuid>>
    > = ({ signal }) =>
        getRequestJobsFilesAsArchiveByJobUuid(jobUuid, params, requestOptions, signal)

    return { queryKey, queryFn, enabled: !!jobUuid, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getRequestJobsFilesAsArchiveByJobUuid>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRequestJobsFilesAsArchiveByJobUuidQueryResult = NonNullable<
    Awaited<ReturnType<typeof getRequestJobsFilesAsArchiveByJobUuid>>
>
export type GetRequestJobsFilesAsArchiveByJobUuidQueryError =
    ErrorType<void | HTTPValidationErrorDTO>

export function useGetRequestJobsFilesAsArchiveByJobUuid<
    TData = Awaited<ReturnType<typeof getRequestJobsFilesAsArchiveByJobUuid>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    params: GetRequestJobsFilesAsArchiveByJobUuidParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobsFilesAsArchiveByJobUuid>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRequestJobsFilesAsArchiveByJobUuid>>,
                    TError,
                    Awaited<ReturnType<typeof getRequestJobsFilesAsArchiveByJobUuid>>
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRequestJobsFilesAsArchiveByJobUuid<
    TData = Awaited<ReturnType<typeof getRequestJobsFilesAsArchiveByJobUuid>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    params: GetRequestJobsFilesAsArchiveByJobUuidParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobsFilesAsArchiveByJobUuid>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRequestJobsFilesAsArchiveByJobUuid>>,
                    TError,
                    Awaited<ReturnType<typeof getRequestJobsFilesAsArchiveByJobUuid>>
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRequestJobsFilesAsArchiveByJobUuid<
    TData = Awaited<ReturnType<typeof getRequestJobsFilesAsArchiveByJobUuid>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    params: GetRequestJobsFilesAsArchiveByJobUuidParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobsFilesAsArchiveByJobUuid>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Files As Archive
 */

export function useGetRequestJobsFilesAsArchiveByJobUuid<
    TData = Awaited<ReturnType<typeof getRequestJobsFilesAsArchiveByJobUuid>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    params: GetRequestJobsFilesAsArchiveByJobUuidParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobsFilesAsArchiveByJobUuid>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getGetRequestJobsFilesAsArchiveByJobUuidQueryOptions(
        jobUuid,
        params,
        options,
    )

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>
    }

    query.queryKey = queryOptions.queryKey

    return query
}

/**
 * This is a method to get files as archived file.

 * @summary Post Files As Archive
 */
export const postRequestJobsFilesAsArchiveByJobUuid = (
    jobUuid: string,
    postRequestJobsFilesAsArchiveByJobUuidBodies: BodyType<string[]>,
    params: PostRequestJobsFilesAsArchiveByJobUuidParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<unknown>(
        {
            url: `/jobs/${encodeURIComponent(String(jobUuid))}/files_as_archive`,
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            data: postRequestJobsFilesAsArchiveByJobUuidBodies,
            params,
            signal,
        },
        options,
    )
}

export const getPostRequestJobsFilesAsArchiveByJobUuidMutationOptions = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postRequestJobsFilesAsArchiveByJobUuid>>,
        TError,
        {
            jobUuid: string
            data: BodyType<string[]>
            params: PostRequestJobsFilesAsArchiveByJobUuidParams
        },
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof postRequestJobsFilesAsArchiveByJobUuid>>,
    TError,
    {
        jobUuid: string
        data: BodyType<string[]>
        params: PostRequestJobsFilesAsArchiveByJobUuidParams
    },
    TContext
> => {
    const mutationKey = ['postRequestJobsFilesAsArchiveByJobUuid']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postRequestJobsFilesAsArchiveByJobUuid>>,
        {
            jobUuid: string
            data: BodyType<string[]>
            params: PostRequestJobsFilesAsArchiveByJobUuidParams
        }
    > = (props) => {
        const { jobUuid, data, params } = props ?? {}

        return postRequestJobsFilesAsArchiveByJobUuid(jobUuid, data, params, requestOptions)
    }

    return { mutationFn, ...mutationOptions }
}

export type PostRequestJobsFilesAsArchiveByJobUuidMutationResult = NonNullable<
    Awaited<ReturnType<typeof postRequestJobsFilesAsArchiveByJobUuid>>
>
export type PostRequestJobsFilesAsArchiveByJobUuidMutationBody = BodyType<string[]>
export type PostRequestJobsFilesAsArchiveByJobUuidMutationError =
    ErrorType<void | HTTPValidationErrorDTO>

/**
 * @summary Post Files As Archive
 */
export const usePostRequestJobsFilesAsArchiveByJobUuid = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postRequestJobsFilesAsArchiveByJobUuid>>,
            TError,
            {
                jobUuid: string
                data: BodyType<string[]>
                params: PostRequestJobsFilesAsArchiveByJobUuidParams
            },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof postRequestJobsFilesAsArchiveByJobUuid>>,
    TError,
    {
        jobUuid: string
        data: BodyType<string[]>
        params: PostRequestJobsFilesAsArchiveByJobUuidParams
    },
    TContext
> => {
    const mutationOptions = getPostRequestJobsFilesAsArchiveByJobUuidMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
/**
 * This is a method to download all deleted files from trash can for a job.

 * @summary Get Files From Trash As Archive
 */
export const getRequestJobsFilesFromTrashAsArchiveByJobUuid = (
    jobUuid: string,
    params: GetRequestJobsFilesFromTrashAsArchiveByJobUuidParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<unknown>(
        {
            url: `/jobs/${encodeURIComponent(String(jobUuid))}/files_from_trash_as_archive`,
            method: 'GET',
            params,
            signal,
        },
        options,
    )
}

export const getGetRequestJobsFilesFromTrashAsArchiveByJobUuidQueryKey = (
    jobUuid?: string,
    params?: GetRequestJobsFilesFromTrashAsArchiveByJobUuidParams,
) => {
    return [`/jobs/${jobUuid}/files_from_trash_as_archive`, ...(params ? [params] : [])] as const
}

export const getGetRequestJobsFilesFromTrashAsArchiveByJobUuidQueryOptions = <
    TData = Awaited<ReturnType<typeof getRequestJobsFilesFromTrashAsArchiveByJobUuid>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    params: GetRequestJobsFilesFromTrashAsArchiveByJobUuidParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobsFilesFromTrashAsArchiveByJobUuid>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {}

    const queryKey =
        queryOptions?.queryKey ??
        getGetRequestJobsFilesFromTrashAsArchiveByJobUuidQueryKey(jobUuid, params)

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getRequestJobsFilesFromTrashAsArchiveByJobUuid>>
    > = ({ signal }) =>
        getRequestJobsFilesFromTrashAsArchiveByJobUuid(jobUuid, params, requestOptions, signal)

    return { queryKey, queryFn, enabled: !!jobUuid, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getRequestJobsFilesFromTrashAsArchiveByJobUuid>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRequestJobsFilesFromTrashAsArchiveByJobUuidQueryResult = NonNullable<
    Awaited<ReturnType<typeof getRequestJobsFilesFromTrashAsArchiveByJobUuid>>
>
export type GetRequestJobsFilesFromTrashAsArchiveByJobUuidQueryError =
    ErrorType<void | HTTPValidationErrorDTO>

export function useGetRequestJobsFilesFromTrashAsArchiveByJobUuid<
    TData = Awaited<ReturnType<typeof getRequestJobsFilesFromTrashAsArchiveByJobUuid>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    params: GetRequestJobsFilesFromTrashAsArchiveByJobUuidParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobsFilesFromTrashAsArchiveByJobUuid>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRequestJobsFilesFromTrashAsArchiveByJobUuid>>,
                    TError,
                    Awaited<ReturnType<typeof getRequestJobsFilesFromTrashAsArchiveByJobUuid>>
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRequestJobsFilesFromTrashAsArchiveByJobUuid<
    TData = Awaited<ReturnType<typeof getRequestJobsFilesFromTrashAsArchiveByJobUuid>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    params: GetRequestJobsFilesFromTrashAsArchiveByJobUuidParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobsFilesFromTrashAsArchiveByJobUuid>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRequestJobsFilesFromTrashAsArchiveByJobUuid>>,
                    TError,
                    Awaited<ReturnType<typeof getRequestJobsFilesFromTrashAsArchiveByJobUuid>>
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRequestJobsFilesFromTrashAsArchiveByJobUuid<
    TData = Awaited<ReturnType<typeof getRequestJobsFilesFromTrashAsArchiveByJobUuid>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    params: GetRequestJobsFilesFromTrashAsArchiveByJobUuidParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobsFilesFromTrashAsArchiveByJobUuid>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Files From Trash As Archive
 */

export function useGetRequestJobsFilesFromTrashAsArchiveByJobUuid<
    TData = Awaited<ReturnType<typeof getRequestJobsFilesFromTrashAsArchiveByJobUuid>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    params: GetRequestJobsFilesFromTrashAsArchiveByJobUuidParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobsFilesFromTrashAsArchiveByJobUuid>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getGetRequestJobsFilesFromTrashAsArchiveByJobUuidQueryOptions(
        jobUuid,
        params,
        options,
    )

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>
    }

    query.queryKey = queryOptions.queryKey

    return query
}

/**
 * This is a method to get deleted files from trash can as archived file.

 * @summary Post Files From Trash As Archive
 */
export const postRequestJobsFilesFromTrashAsArchiveByJobUuid = (
    jobUuid: string,
    postRequestJobsFilesFromTrashAsArchiveByJobUuidBodies: BodyType<string[]>,
    params: PostRequestJobsFilesFromTrashAsArchiveByJobUuidParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<unknown>(
        {
            url: `/jobs/${encodeURIComponent(String(jobUuid))}/files_from_trash_as_archive`,
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            data: postRequestJobsFilesFromTrashAsArchiveByJobUuidBodies,
            params,
            signal,
        },
        options,
    )
}

export const getPostRequestJobsFilesFromTrashAsArchiveByJobUuidMutationOptions = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postRequestJobsFilesFromTrashAsArchiveByJobUuid>>,
        TError,
        {
            jobUuid: string
            data: BodyType<string[]>
            params: PostRequestJobsFilesFromTrashAsArchiveByJobUuidParams
        },
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof postRequestJobsFilesFromTrashAsArchiveByJobUuid>>,
    TError,
    {
        jobUuid: string
        data: BodyType<string[]>
        params: PostRequestJobsFilesFromTrashAsArchiveByJobUuidParams
    },
    TContext
> => {
    const mutationKey = ['postRequestJobsFilesFromTrashAsArchiveByJobUuid']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postRequestJobsFilesFromTrashAsArchiveByJobUuid>>,
        {
            jobUuid: string
            data: BodyType<string[]>
            params: PostRequestJobsFilesFromTrashAsArchiveByJobUuidParams
        }
    > = (props) => {
        const { jobUuid, data, params } = props ?? {}

        return postRequestJobsFilesFromTrashAsArchiveByJobUuid(
            jobUuid,
            data,
            params,
            requestOptions,
        )
    }

    return { mutationFn, ...mutationOptions }
}

export type PostRequestJobsFilesFromTrashAsArchiveByJobUuidMutationResult = NonNullable<
    Awaited<ReturnType<typeof postRequestJobsFilesFromTrashAsArchiveByJobUuid>>
>
export type PostRequestJobsFilesFromTrashAsArchiveByJobUuidMutationBody = BodyType<string[]>
export type PostRequestJobsFilesFromTrashAsArchiveByJobUuidMutationError =
    ErrorType<void | HTTPValidationErrorDTO>

/**
 * @summary Post Files From Trash As Archive
 */
export const usePostRequestJobsFilesFromTrashAsArchiveByJobUuid = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postRequestJobsFilesFromTrashAsArchiveByJobUuid>>,
            TError,
            {
                jobUuid: string
                data: BodyType<string[]>
                params: PostRequestJobsFilesFromTrashAsArchiveByJobUuidParams
            },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof postRequestJobsFilesFromTrashAsArchiveByJobUuid>>,
    TError,
    {
        jobUuid: string
        data: BodyType<string[]>
        params: PostRequestJobsFilesFromTrashAsArchiveByJobUuidParams
    },
    TContext
> => {
    const mutationOptions =
        getPostRequestJobsFilesFromTrashAsArchiveByJobUuidMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
